export const products = [
  {
    "id": 1,
    "category": "VEGETABLES",
    "name": "jackfruit",
    "created_at": "2012-04-23T18:25:43.511Z",
    "updated_at": "2012-04-23T18:25:43.511Z",
    "image": "https://loremflickr.com/320/240/plant",
    "time_ago": "1 hour ago",
    "farm_name": "Fastfarm"
  },
  {
    "id": 2,
    "category": "FRUITS",
    "name": "apples",
    "created_at": "2012-04-23T18:25:43.511Z",
    "updated_at": "2012-04-23T18:25:43.511Z",
    "image": "https://loremflickr.com/320/240/fruit",
    "time_ago": "2 minutes ago",
    "farm_name": "Dairyfarm"
  },
  {
    "id": 3,
    "category": "FRUITS",
    "name": "apples",
    "created_at": "2012-04-23T18:25:43.511Z",
    "updated_at": "2012-04-23T18:25:43.511Z",
    "image": "https://loremflickr.com/320/240/food",
    "time_ago": "2 hours ago",
    "farm_name": "Dairyfarm"
  },
  {
    "id": 4,
    "category": "SALADS",
    "name": "lemon",
    "created_at": "2012-04-23T18:25:43.511Z",
    "updated_at": "2012-04-23T18:25:43.511Z",
    "image": "https://loremflickr.com/320/240?vegetable",
    "time_ago": "24 hours ago",
    "farm_name": "Fastfarm"
  },
  {
    "id": 5,
    "category": "SALADS",
    "name": "grapes",
    "created_at": "2012-04-23T18:25:43.511Z",
    "updated_at": "2012-04-23T18:25:43.511Z",
    "image": "https://loremflickr.com/320/240/grape",
    "time_ago": "12 hours ago",
    "farm_name": "Dairyfarm"
  },
  {
    "id": 6,
    "category": "VEGETABLES",
    "name": "pears",
    "created_at": "2012-04-23T18:25:43.511Z",
    "updated_at": "2012-04-23T18:25:43.511Z",
    "image": "https://loremflickr.com/320/240/bean",
    "time_ago": "30 minutes ago",
    "farm_name": "Fastfarm"
  },
  {
    "id": 7,
    "category": "SALADS",
    "name": "bananas",
    "created_at": "2012-04-23T18:25:43.511Z",
    "updated_at": "2012-04-23T18:25:43.511Z",
    "image": "https://loremflickr.com/320/240/goat",
    "time_ago": "23 hours ago",
    "farm_name": "Fastfarm"
  },
  {
    "id": 8,
    "category": "VEGETABLES",
    "name": "pineapples",
    "created_at": "2012-04-23T18:25:43.511Z",
    "updated_at": "2012-04-23T18:25:43.511Z",
    "image": "https://loremflickr.com/320/240/chicken",
    "time_ago": "1 day ago",
    "farm_name": "Fastfarm"
  },
  {
    "id": 9,
    "category": "SALADS",
    "name": "coconuts",
    "created_at": "2012-04-23T18:25:43.511Z",
    "updated_at": "2012-04-23T18:25:43.511Z",
    "image": "https://loremflickr.com/320/240/salad",
    "time_ago": "10 days ago",
    "farm_name": "Fastfarm"
  }
]